import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormGroupedByCategoryVM, FormUploadVM, IdNameVM, SiteCodes, UpdateHistoryVM, UsersVM, VMDataForUpload } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { SafetyFormsService } from '../services/safety-forms.service';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { FileReaderEvent } from '../setup-implement/setup-implement.component';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.css'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class UploadFormComponent implements OnInit {

  fileData: File = null;
  today = new Date();

  constructor(private http: HttpClient,
    private SafetyFormsService_:SafetyFormsService,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _sanitizer: DomSanitizer,
    private _safetyConfigService:SafetyConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private _appService: AppService,
    private _notify: NotificationsService,
    private _inductionService: SafetyInductionService,
    @Inject(DOCUMENT) private document: Document) {
    this.today.setDate(this.today.getDate());
     }

    UploadFormId:number=0
    groupedForms:FormGroupedByCategoryVM[]
    groupedForms_:FormGroupedByCategoryVM[]
    Forms:FormGroupedByCategoryVM[];
    UploadData:VMDataForUpload
    incidentTypes: IdNameVM[]
    users:UsersVM[]=[]
    Image
  ImageList: string[] = [];
    selectedFile: FileList;
    UploadFile
  FileList: string[] = [];
  UploadedFiles: string[] = [];
  UploadedImages: string[] = [];
    siteCodesList: SiteCodes[]=[];
    dateCompleted
    inputForm
    reportIncidentID=""
    incidentType
    relatedUser
    inputValuestate
    Notes
    isActiveFollowUpRequired:boolean
    isActiveFollowUpCompleted:boolean
    fololowupDate
    fololowupUser
    FileName :string = "";
    NewFileName: string = "";
    FilePreview: string = "";
    FormCategoryId_
    FormUploadedData:FormUploadVM
    AddformID:number=0
    checkIsAdmin:boolean
    updateHistory:UpdateHistoryVM
    RequireIncidentNo:boolean
    isRequireIncidentNo:boolean
    AddedByUser
    DateAdded
    DateModified
    ModifiedByUser
    FormCategoryID
  count: number = 0;
  savingForm: boolean;
  fileHeader = new Map();
  isLoading: boolean = false;

  
ngOnInit() {
  this._appService.setPageTitle('Upload Paper Forms');
  this.base64FileHeaderMapper();
    this.GetFormsAndFormCategories();
    this.GetIncidentTypesForDropDownLists();
    this.GetUsers();
    this.loadSiteList();
    this.upload();
  }

  sanitize(image: string) {
    //console.log(Image)
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`); 
  }

  uploadPhoto(newPhoto: string) {
    this.ImageList.push(newPhoto.split(",")[1])
   // this.Image = newPhoto.split(",")[1];
   // let Imgarray = [];
   // Imgarray.push(this.Image);
   //if( this.ImageList!=null)
   //{
   //  this.ImageList.push(this.Image)
   //}
   //else
   // this.ImageList=Imgarray
   // console.log(this.ImageList)
  }

  uploadFile(newFile: string) {
    this.FileList.push(newFile.split(",")[1])
    //this.UploadFile = newFile.split(",")[1];
   // let Filearray = [];
   // Filearray.push(this.UploadFile);
   //if( this.FileList!=null)
   //{
   //  this.FileList.push(this.UploadFile)
   //}
   //else
   // this.FileList=Filearray
   // console.log(this.ImageList)
  }


  onSelectPhoto(event: any) {
    //if (event.target.files && event.target.files[0]) {
    //  var reader = new FileReader();
    //  this.selectedFile = event.target.files[0];
    //  reader.onloadend = (e) => {
    //    this.uploadPhoto(reader.result as string);
        
    //  }
    //  reader.readAsDataURL(event.target.files[0]);
    //}
    ////if (event.target.files && event.target.files[0]) {
    ////  for (var i = 0; i < event.target.files.length; i++) {
    ////    if (this.UploadedImages.indexOf(event.target.files[i]["name"]) < 0) {
    ////      this.UploadedImages.push(event.target.files[i]["name"]);
    ////      this.ImageList.push(this.readFileAsBase64String(event.target.files[i]));
    ////      var reader = new FileReader();
    ////      reader.onloadend = (e) => {
    ////        this.uploadPhoto(reader.result as string);
    ////      }
    ////      reader.readAsDataURL(event.target.files[i]);
    ////    }
    ////  }
    ////}
      if (event.target.files && event.target.files[0]) {
        for (let i = 0; i < event.target.files.length; i++) {
          if (this.UploadedImages.indexOf(event.target.files[i]["name"]) < 0) {
            this.UploadedImages.push(event.target.files[i]["name"]);
            var reader = new FileReader();
            reader.onload = (event: any) => {
              this.ImageList.push(event.target["result"].split(",")[1])
            };
            reader.readAsDataURL(event.target.files[i]);
          }
        }
      }
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
}
 
onSubmit() {
    const formData = new FormData();
    formData.append('file', this.fileData);
    this.http.post('url/to/your/api', formData)
      .subscribe(res => {
       // console.log(res);
        alert('SUCCESS !!');
      })
}

GetFormsAndFormCategories()
{
  this.SafetyFormsService_.GetActiveFormsForDropDownListisNotDigital().subscribe(res =>{ 
  this.groupedForms=res
  
 // console.log("frm categories", this.groupedForms)
  
})

}

ClickForm(FormCat:FormGroupedByCategoryVM){
 // console.log("Data__11", FormCat)
  if(FormCat.RequireIncidentNo == true){
    this.isRequireIncidentNo=true
  }else{
    this.isRequireIncidentNo=false;
  }
}


GetIncidentTypesForDropDownLists()
{
  this.SafetyFormsService_.GetIncidentTypesForDropDownLists().subscribe(res=>
    {
      this.incidentTypes=res;
     // console.log("Incident types",this.incidentTypes)
    })
}

GetUsers()
{
  this._safetyGeneraldashboardService.GetUsersForSafetyApp().subscribe(res=>{
    this.users=res
 //   console.log("persons", res)
    // res.map(x=>{
    // //  this.UserName=x.UserName
    // }
    //   )    
  })
}

state = new FormControl("", [Validators.required]);
getErrorMessage() {
  return this.state.hasError("required") ? "You must enter a value" : "";
}

loadSiteList()
{
 this._safetyConfigService.getAllSitesList().subscribe(sites =>
 { 
  // console.log('sitelist',sites)
   this.siteCodesList=sites;
   
 });
}

  onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (this.UploadedFiles.indexOf(event.target.files[i]["name"]) < 0) {
          this.UploadedFiles.push(event.target.files[i]["name"]);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.FileList.push(event.target["result"].split(",")[1])
          };
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    }
  }

Deletefilename(filename: any) {
  for (var i = 0; i < this.FileList.length; i++) {
    if (this.FileList[i]["name"] == filename) {
      this.FileList.splice(i, 1);
      this.UploadedFiles.splice(i, 1);
    }
  }
}

AddCompletedFormWithState()
{

  if(this.dateCompleted==null){
    this._notify.error('Please enter the Date Completed');
    
    return
  }
 else if(this.inputForm==null){
  this._notify.error('Please select a form');
    
    return
  }
  
// else if(this.FilePreview==""){
//   
//this._notify.error('Please upload a file.');
//     return
//   }
  
  else if(this.inputValuestate==null || this.inputValuestate==0){
    this._notify.error('Please enter the State');
    return
  }
  else{
   // this.isLoading= true;
    this.savingForm = true;
    const model = new FormUploadVM();
     model.DateCompleted=this.dateCompleted
  model.Form=this.inputForm
  model.IncidentId=this.reportIncidentID
  model.IncidentType= this.incidentType
  model.RelatedUser=this.relatedUser
  model.SiteId=this.inputValuestate
  model.Notes=this.Notes
  model.FollowUpRequired=this.isActiveFollowUpRequired
  model.FollowUpCompleted=this.isActiveFollowUpCompleted
  model.FollowUpDate=this.fololowupDate
  model.FollowUpUser=this.fololowupUser
  model.Images=this.ImageList
  model.FormFiles=this.FileList
  
    this.SafetyFormsService_.AddCompletedFormWithState(model).subscribe(res =>
    {//console.log("Addcompletedforms",res)
     // this.FormUploadedData=res
     this.AddformID=res
    
     if(res>0){
    
      this._notify.success('Successfully Saved');
//this.isdisablesave=true;
this.reload();
//this.isLoading= false;
     }       
      this.savingForm = false;
     // this.isLoading= false;
    })
    //TT-5071 removed refresh
    //this.reload();
   
    
  
  }
}

upload()
{
  this._inductionService.uploadFormData(this.UploadFormId).subscribe(resupload=>
    {
     this.UploadData=resupload
    //console.log('upload res', resupload)
   this.checkIsAdmin=resupload.IsAdmin
   this.updateHistory=this.UploadData.UpdateHistory
this.Forms=this.UploadData.Forms

this.groupedForms_=resupload.Forms


    })
}




GetAdminLinkToAddUsers()
{
  this.router.navigate(['/administrator']);
  // this.SafetyFormsService_.GetAdminLinkToAddUsers().subscribe(res=>
  //   {
  //     //console.log(res)
  //     window.open(res);
  //   })
}

@ViewChild('fileUploader') fileUploader:ElementRef;
@ViewChild('fileUploader_') fileUploader_:ElementRef;
reload(){
  this.isLoading= true;
 this.dateCompleted = null;
 this.inputForm=0;
 this.reportIncidentID = "";
 this.incidentType = 0;
 this.inputValuestate=0;
 this.ImageList = []; 
  this.FileList = [];
  this.UploadedFiles = [];
 this.Image="";
 this.relatedUser = null;
 this.Notes = "";
 this.isActiveFollowUpRequired = false;
 this.isActiveFollowUpCompleted = false;
 this.fololowupDate = null;
 this.fololowupUser = null;
 this.fileUploader.nativeElement.value = null;
 this.fileUploader_.nativeElement.value = null;
 this.isLoading= false;
}

// refresh(): void {
//   window.location.reload();
// }
Delete()
{
  //console.log("form ID" , this.AddformID)
  if(this.dateCompleted==null){
    this._notify.error('Please enter the Date Completed');
    
    return
  }
 else if(this.inputForm==null){
  this._notify.error('Please select a form');
   
    return
  }
  
else if(this.FilePreview==""){
  this._notify.error('Please upload a file');
    
    return
  }
  else{
    this.savingForm= true;
  this.SafetyFormsService_.DeleteForm(2366).subscribe(res=>
    {
      
      this._notify.success('Successfully Deleted');

      this.savingForm= false;
    });
}
  }

  DownloadForm(indx) {
    debugger;
    var _FileData = this.FileList[indx];
    var extention = this.getFileType(_FileData);
    var arrBuffer = this.base64ToArrayBuffer(_FileData);

    if (extention == 'pdf') {
      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "UploadedFormFile.pdf";
      link.click();
    }
    else if (extention == 'xls' || extention == 'xlsx') {
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "UploadedFormFile." + extention;
      link.click();
    }
    else if (extention == 'doc' || extention == 'docx') {
      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "UploadedFormDoc." + extention;
      link.click();
    }
    //else if (extention == 'docx') {
    //  var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    //  var link = document.createElement('a');
    //  link.href = window.URL.createObjectURL(blob);
    //  link.download = this.NewFileName;
    //  link.click();
    //}

    //else if (extention == 'txt') {
    //  var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
    //  var link = document.createElement('a');
    //  link.href = window.URL.createObjectURL(blob);
    //  link.download = this.NewFileName
    //  link.click();
    //}
    //else if (extention == 'doc') {
    //  var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    //  var link = document.createElement('a');
    //  link.href = window.URL.createObjectURL(blob);
    //  link.download = this.NewFileName;
    //  link.click();
    //}
  }
  base64ToArrayBuffer(data) {
    var binaryString = window.atob(data);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };
base64FileHeaderMapper() {
  //get the first 3 char of base64
  this.fileHeader.set("/9j", "jpg")
  this.fileHeader.set("iVB", "png")
  this.fileHeader.set("Qk0", "bmp")
  this.fileHeader.set("SUk", "tiff")
  this.fileHeader.set("JVB", "pdf")
  this.fileHeader.set("UEs", "doc")
  this.fileHeader.set("RXF", "xls")
}

getFileType(fileBase64) {
  let res = ""
  this.fileHeader.forEach((v, k) => {
    if (k == fileBase64.substr(0, 3)) {
      res = v
    }
  })
  //if file is not supported
  if (res == "") {
    res = "unknown"
  }
  //return map value
  return res;
}

}
